<template>
  <div>
    <Head :title="title" />

    <jet-banner />
    <div class="min-h-screen bg-gray-100">
      <div>
        <!-- main header-->
        <nav class="bg-white border-b border-gray-100">
          <!-- Primary Navigation Menu -->
          <div class="max-w-7xl mx-auto xl:px-4 lg:px-4 px-5">
            <div class="flex justify-between h-16">
              <div class="flex">
                <!-- Logo -->
                <div class="flex-shrink-0 flex items-center">
                  <jet-application-mark class="block h-9 w-auto" />
                </div>
              </div>

              <div class="hidden sm:flex sm:items-center sm:ml-6">
                <div v-if="canAccessAdminSettings()" class="ml-3 relative">
                  <jet-button
                    @click="gotoUpgrade()"
                    class="hover:no-underline normal-case text-sm font-semibold rounded-full border-2 border-success xl:px-4 lg:px-3 py-2"
                    style="background-color: #ffff; color: black !important"
                  >
                    <img
                      :src="'/imgs/upgrade_ic1.png'"
                      class=""
                      alt=""
                      aria-hidden="false"
                    />
                    <span class="hidden lg:inline">&nbsp;Upgrade</span>
                  </jet-button>
                </div>

                <div class="ml-3 relative">
                  <!-- Teams Dropdown -->
                  <jet-dropdown
                    align="right"
                    width="96"
                    v-if="$page.props.jetstream.hasTeamFeatures"
                  >
                    <template #trigger>
                      <span class="inline-flex rounded-md">
                        <button
                          type="button"
                          class="inline-flex items-center px-3 py-2 border border-transparent xl:text-sm lg:text-sm text-xs leading-4 font-medium rounded-md text-gray-500 bg-white hover:bg-gray-50 hover:text-gray-700 focus:outline-none focus:bg-gray-50 active:bg-gray-50 transition"
                        >
                          <!-- {{ $page.props.user.current_team.name }} -->
                          {{ current_tenant_name }}

                          <svg
                            class="ml-2 -mr-0.5 h-4 w-4"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </button>
                      </span>
                    </template>

                    <template #content>
                      <div class="w-48">
                        <!-- Team Management -->
                        <template v-if="$page.props.jetstream.hasTeamFeatures">
                          <div class="block px-4 py-2 text-xs text-gray-400">
                            Admin
                          </div>

                          <!-- Tenant Admin Settings -->

                          <!-- Team Settings -->
                          <jet-dropdown-link
                            v-if="canAccessAdminSettings()"
                            :href="route('tenant-admin-panels.users', 'admin')"
                          >
                            Tenant Admin Settings
                          </jet-dropdown-link>

                          <jet-dropdown-link
                            :href="route('menu-management', 'builder')"
                          >
                            Menu Management
                          </jet-dropdown-link>

                          <div class="border-t border-gray-100"></div>

                          <!-- Team Switcher -->
                          <div class="block px-4 py-2 text-xs text-gray-400">
                            Switch Teams
                          </div>

                          <template
                            v-for="team in $page.props.user.all_teams"
                            :key="team.id"
                          >
                            <form @submit.prevent="switchToTeam(team)">
                              <jet-dropdown-link as="button">
                                <div class="flex items-center">
                                  <svg
                                    v-if="
                                      team.id ==
                                      $page.props.user.current_team_id
                                    "
                                    class="mr-2 h-5 w-5 text-green-400"
                                    fill="none"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                    ></path>
                                  </svg>
                                  <div>{{ team.name }}</div>
                                </div>
                              </jet-dropdown-link>
                            </form>
                          </template>

                          <!-- Team Switcher -->
                          <div class="block px-4 py-2 text-xs text-gray-400">
                            Switch Tenant
                          </div>

                          <template
                            v-for="tenant in tenantData"
                            :key="tenant.id"
                          >
                            <form @submit.prevent="switchToTenant(tenant)">
                              <jet-dropdown-link as="button">
                                <div class="flex items-center">
                                  <svg
                                    v-if="tenant.id == current_tenant_id"
                                    class="mr-2 h-5 w-5 text-green-400"
                                    fill="none"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                    ></path>
                                  </svg>
                                  <div>{{ tenant.name }}</div>
                                </div>
                              </jet-dropdown-link>
                            </form>
                          </template>
                        </template>
                      </div>
                    </template>
                  </jet-dropdown>
                </div>

                &nbsp; &nbsp;
                <jet-Nav-icon>
                  <i class="fas fa-bell"></i>
                </jet-Nav-icon>

                <!-- Settings Dropdown -->
                <div class="ml-3 relative">
                  <jet-dropdown align="right" width="48">
                    <template #trigger>
                      <button
                        v-if="$page.props.jetstream.managesProfilePhotos"
                        class="flex text-sm border-2 border-transparent rounded-full focus:outline-none focus:border-gray-300 transition"
                      >
                        <img
                          class="h-8 w-8 rounded-full object-cover"
                          :src="$page.props.user.profile_photo_url"
                          :alt="$page.props.user.name"
                        />
                      </button>

                      <span v-else class="inline-flex rounded-md">
                        <button
                          type="button"
                          class="inline-flex items-center text-sm leading-4 font-medium rounded-md text-gray-500 bg-white hover:text-gray-700 focus:outline-none transition"
                        >
                          <!-- {{ $page.props.user.name }} -->

                          <i class="fas fa-user-circle text-2xl"></i>
                        </button>
                      </span>
                    </template>

                    <template #content>
                      <!-- Account Management -->
                      <div class="block px-4 py-2 text-xs text-gray-400">
                        Manage Account
                      </div>

                      <div class="border-t border-gray-100"></div>

                      <!-- <jet-icon
                            :active="route().current('tallyclinicconfigurations.index')"
                            :href="'/builder/configurations'"
                          >
                            <i class="fas fa-cog"></i>
                          </jet-icon> -->

                      <jet-dropdown-link
                        as="button"
                        :active="
                          route().current('tallyclinicconfigurations.index')
                        "
                        :href="'/builder/configurations'"
                      >
                        <div class="flex items-center">
                          <i class="fas fa-cog"></i>
                          <div class="px-3 text-xs text-gray-500">Settings</div>
                        </div>
                      </jet-dropdown-link>

                      <jet-dropdown-link as="button">
                        <div class="flex items-center">
                          <i class="fas fa-headset"></i>
                          <div class="px-3 text-xs text-gray-500">Support</div>
                        </div>
                      </jet-dropdown-link>

                      <div class="border-t border-gray-100"></div>

                      <!-- Authentication -->
                      <form @submit.prevent="logout">
                        <jet-dropdown-link as="button">
                          Log Out
                        </jet-dropdown-link>
                      </form>
                    </template>
                  </jet-dropdown>
                </div>
              </div>

              <!-- Hamburger -->
              <div class="-mr-2 flex items-center sm:hidden">
                <button
                  @click="
                    showingNavigationDropdown = !showingNavigationDropdown
                  "
                  class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition"
                >
                  <svg
                    class="h-6 w-6"
                    stroke="currentColor"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      :class="{
                        hidden: showingNavigationDropdown,
                        'inline-flex': !showingNavigationDropdown,
                      }"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                    <path
                      :class="{
                        hidden: !showingNavigationDropdown,
                        'inline-flex': showingNavigationDropdown,
                      }"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <!-- Responsive Navigation Menu -->
          <div
            :class="{
              block: showingNavigationDropdown,
              hidden: !showingNavigationDropdown,
            }"
            class="sm:hidden"
          >
            <div class="pt-2 pb-3 space-y-1">
              <jet-responsive-nav-link> Dashboard </jet-responsive-nav-link>
            </div>
            <!-- Responsive Settings Options -->
            <div class="pt-4 pb-1 border-t border-gray-200">
              <div class="flex items-center px-4">
                <div
                  v-if="$page.props.jetstream.managesProfilePhotos"
                  class="flex-shrink-0 mr-3"
                >
                  <img
                    class="h-10 w-10 rounded-full object-cover"
                    :src="$page.props.user.profile_photo_url"
                    :alt="$page.props.user.name"
                  />
                </div>
                <div>
                  <div class="font-medium text-base text-gray-800">
                    {{ $page.props.user.name }}
                  </div>
                  <div class="font-medium text-sm text-gray-500">
                    {{ $page.props.user.email }}
                  </div>
                </div>
              </div>
              <div class="mt-3 space-y-1">
                <jet-responsive-nav-link
                  :href="route('profile.show')"
                  :active="route().current('profile.show')"
                >
                  Profile
                </jet-responsive-nav-link>

                <jet-responsive-nav-link
                  :href="route('api-tokens.index')"
                  :active="route().current('api-tokens.index')"
                  v-if="$page.props.jetstream.hasApiFeatures"
                >
                  API Tokens
                </jet-responsive-nav-link>
                <!-- Authentication -->
                <form method="POST" @submit.prevent="logout">
                  <jet-responsive-nav-link as="button">
                    Log Out
                  </jet-responsive-nav-link>
                </form>
                <!-- Team Management -->
                <template v-if="$page.props.jetstream.hasTeamFeatures">
                  <div class="border-t border-gray-200"></div>

                  <div class="block px-4 py-2 text-xs text-gray-400">
                    Manage Team
                  </div>
                  <!-- Team Settings -->
                  <jet-responsive-nav-link
                    :href="route('teams.show', $page.props.user.current_team)"
                    :active="route().current('teams.show')"
                  >
                    Team Settings
                  </jet-responsive-nav-link>

                  <jet-responsive-nav-link
                    :href="route('teams.create')"
                    :active="route().current('teams.create')"
                    v-if="$page.props.jetstream.canCreateTeams"
                  >
                    Create New Team
                  </jet-responsive-nav-link>

                  <div class="border-t border-gray-200"></div>
                  <!-- Team Switcher -->
                  <div class="block px-4 py-2 text-xs text-gray-400">
                    Switch Teams
                  </div>
                  <template
                    v-for="team in $page.props.user.all_teams"
                    :key="team.id"
                  >
                    <form @submit.prevent="switchToTeam(team)">
                      <jet-responsive-nav-link as="button">
                        <div class="flex items-center">
                          <svg
                            v-if="team.id == $page.props.user.current_team_id"
                            class="mr-2 h-5 w-5 text-green-400"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                            ></path>
                          </svg>
                          <div>{{ team.name }}</div>
                        </div>
                      </jet-responsive-nav-link>
                    </form>
                  </template>
                </template>
              </div>
            </div>
          </div>
        </nav>
      </div>

      <div class="flex">
        <div class="flex-none bg-white">
          <div v-if="$slots.sidenav" class="bg-white border-b border-gray-100">
            <!-- vertical navigation-->
            <side-nav v-if="$slots.sidenav">
              <slot name="sidenav"></slot>
            </side-nav>
          </div>

          <div
            v-if="$slots.dashboardnav"
            class="bg-white border-b border-gray-100"
          >
            <!-- vertical navigation-->

            <dashboard-nav v-if="$slots.dashboardnav">
              <slot name="dashboardnav"></slot>
            </dashboard-nav>
          </div>

          <div
            v-if="$slots.tcmainnav"
            class="bg-white border-b border-gray-100"
          >
            <tc-main-nav>
              <slot name="tcmainnav"></slot>
            </tc-main-nav>
          </div>

          <div v-if="$slots.adminnav" class="bg-white border-b border-gray-100">
            <admin-nav>
              <slot name="admin-nav"></slot>
            </admin-nav>
          </div>

          <div
            v-if="$slots.tcsetttingnav"
            class="border-b border-gray-100 col-span-1"
            style="background-color: #f3f4f6"
          >
            <!-- vertical navigation-->
            <tc-setting-nav v-if="$slots.tcsetttingnav">
              <slot name="tcsetttingnav"></slot>
            </tc-setting-nav>
          </div>
        </div>

        <div class="flex-1">
          <!--  horizontal navigation -->
          <div v-if="$slots.horizonav">
            <!-- <nav-bar v-if="$slots.horizonav">
              <slot name="horizonav"></slot>
               </nav-bar> -->
            <slot name="horizonav"></slot>
          </div>
          <!-- tally clinic  horizontal navigation-->
          <div v-if="$slots.tctopnav">
            <tc-top-navbar v-if="$slots.tctopnav">
              <slot name="tctopnav"></slot>
            </tc-top-navbar>
          </div>

          <header class="bg-white shadow" v-if="$slots.header">
            <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
              <slot name="header"></slot>
            </div>
          </header>
          <main>
            <slot></slot>
          </main>
        </div>
      </div>

      <DxPopup
        v-model:visible="popupVisible"
        :drag-enabled="true"
        :show-close-button="true"
        :close-on-outside-click="false"
        :show-title="true"
        :resizeEnabled="true"
        :width="400"
        :height="270"
      >
        <template #contentTemplate>
          <div class="flex flex-col items-center justify-center py-4">
            <!-- Image -->
            <img
              :src="'/imgs/sync.png'"
              alt="Update Image"
              class="w-16 h-16 mb-3"
            />
            <!-- <img src="your-image-url.jpg" alt="Update Image" class="w-16 h-16 mb-4" /> -->
            <!-- Paragraph -->
            <h4 class="font-semibold">Update Available</h4>
            <p class="text-center px-4">
              A new update is available. Please update to the latest version for
              the best experience.
            </p>
          </div>
          <!-- button start -->
          <!-- <div class="mx-3">
      <button type="submit" class="w-full text-white bg-green-500 hover:bg-green-600 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-1 text-center dark:bg-green-500 dark:hover:bg-green-500 dark:focus:ring-green-600">Update</button>
       </div> -->
        </template>
        <DxToolbarItem
          widget="dxButton"
          toolbar="bottom"
          stylingMode="contained"
          location="center"
          :options="saveButtonOptions"
        />
      </DxPopup>
    </div>
  </div>
</template>
<script>
import JetApplicationMark from "@/Jetstream/ApplicationMark.vue";
import JetNavIcon from "@/Jetstream/NavIcon";

import JetButton from "@/Jetstream/Button.vue";
import TcTopNavbar from "./TallyClinicTopNavbar.vue";
import JetBanner from "@/Jetstream/Banner.vue";
import JetDropdown from "@/Jetstream/Dropdown.vue";
import JetDropdownLink from "@/Jetstream/DropdownLink.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";
import JetResponsiveNavLink from "@/Jetstream/ResponsiveNavLink.vue";
import { Head, Link } from "@inertiajs/inertia-vue3";
import NavBar from "./NavBar.vue";
import SideNav from "./SideNav.vue";
import DashboardNav from "./DashboardSideNav.vue";
import TcSettingNav from "./TcSettingNav.vue";
import AdminNav from "./TenantAdminNav.vue";
import TcMainNav from "./TcMainNav.vue";
import { DxPopup, DxPosition, DxToolbarItem } from "devextreme-vue/popup";

export default {
  props: {
    title: String,
  },
  components: {
    AdminNav,
    JetNavIcon,
    JetButton,
    Head,
    JetApplicationMark,
    JetBanner,
    JetDropdown,
    JetDropdownLink,
    JetNavLink,
    NavBar,
    JetResponsiveNavLink,
    Link,
    SideNav,
    TcSettingNav,
    TcMainNav,
    TcTopNavbar,
    DashboardNav,
    DxPopup,
    DxPosition,
    DxToolbarItem,
  },
  data() {
    return {
      popupVisible: false,
      showingNavigationDropdown: false,
      tenantData: null,
      current_tenant_id: null,
      current_tenant_name: "",
      updateAvailable: this.$page.props.updateAvailable,
      updateIds: this.$page.props.updateIds,
      saveButtonOptions: {
        text: "Update",
        elementAttr: {
          style: "width: 100%; background-color: #28a745; color: white;",
        },
        onClick: () => {
          this.$inertia.post(route("updates.update-product", "all"), {
            updateIds: this.updateIds,
          });
          this.popupVisible = false;
        },
      },
    };
  },
  methods: {
    setTenant() {
      this.current_tenant_id = window.env.current_tenant_id;
    },
    switchToTeam(team) {
      this.$inertia.put(
        route("current-team.update"),
        {
          team_id: team.id,
        },
        {
          preserveState: false,
        }
      );
    },
    switchToTenant(tenant) {
      console.log(tenant.portal_hostname + "/dashboard");
      window.location.href = this.$utils.goToUrl(
        tenant.portal_hostname + "/dashboard"
      );
      //this.$inertia.visit(tenant.portal_hostname+'/dashboard');
    },
    getOrganisation() {
      axios.get("/user-related-tenant").then((response) => {
        //console.log("user tenant", response);
        // this.currentTenantId = response.data.tenant;
        //this.protocolHost =  response.data.results.data.portal_hostname + "/dashboard";

        this.tenantData = response.data.data;
        this.current_tenant_name =
          this.tenantData?.find((item) => item.id === this.current_tenant_id)
            ?.name ?? "";
      });
    },
    logout() {
      this.$inertia.post(route("logout"));
    },
    gotoUpgrade() {
      this.$inertia.get(route("tenant-admin-panels.subscriptions", "admin"));
      //  this.$inertia.get(route("marketplaces.upgradeproduct"));
    },
    canAccessAdminSettings() {
      // Check if userpermision and role exist

      console.log(
        "canAccessAdminSettings Role",
        this.$page.props.userpermision.isAdmin
      );

      if (
        !this.$page.props.userpermision ||
        !this.$page.props.userpermision.isAdmin
      ) {
        return false; // Don't show admin settings if role info is missing
      }
      // console.log("canAccessAdminSettings",this.$page.props.user);
      //  const allowedRoles = ["super-admin"];

      return this.$page.props.userpermision.isAdmin;

      // return allowedRoles.includes(this.$page.props.userpermision.role.name);
      // return this.$page.props.userpermision.role.name === "super-admin";
    },
  },
  mounted() {
    this.setTenant();
    this.getOrganisation();
    this.canAccessAdminSettings();

    if (this.updateAvailable) {
      this.popupVisible = true;
    }
    console.log("apple : " + this.updateAvailable);
  },
};
</script>
<style scoped>
/* .text-lg{
  font-size: 1.200rem;
line-height: 1.75rem;
} */
/* .text-xs{
  font-size: 0.35rem;
line-height: 0.5rem;
} */
/* .dx-popup-bottom .dx-button {
  min-width: 27.5vw !important;
} */

.dx-popup-content {
  padding: 10px;
  margin: 1px 20px !important;
}
</style>


